// components/RightSidebarFilter.js

import DateRangeCost from "../DateRangeCost";

const RightSidebar = ({ isVisible, onClose, onDateChange }) => {
  return (
    <div
      className={`position-fixed top-0 end-0 bg-white p-4 shadow h-100 zindex-tooltip transition ${
        isVisible ? "d-block" : "d-none"
      }`}
      style={{
        width: "80%",
        maxWidth: "300px",
        zIndex: 1050,
        overflowY: "auto",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ color: "#83c14a" }}
      >
        <h5 className="mb-0">Filters</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>
      <hr />
      <DateRangeCost
        onChange={onDateChange}
        field="created"
        onComplete={onClose}
      />
    </div>
  );
};

export default RightSidebar;
